import { render } from "./Buy.vue?vue&type=template&id=7c506271"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/auctions/Buy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c506271"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c506271', __exports__)) {
    api.reload('7c506271', __exports__)
  }
  
  module.hot.accept("./Buy.vue?vue&type=template&id=7c506271", () => {
    api.rerender('7c506271', render)
  })

}


export default __exports__